module.exports = __webpack_public_path__ + "img/acorn.4b4d929d.png";